var exports = {
  "KE": "VoiceSceneToolbar.module__toolbar___b3F0R0",
  "L$": "VoiceSceneToolbar.module__toggle___b3F0R0",
  "_s": "VoiceSceneToolbar.module__toggleOn___b3F0R0",
  "Kk": "VoiceSceneToolbar.module__icon___b3F0R0",
  "Pf": "VoiceSceneToolbar.module__label___b3F0R0",
};

module.exports = exports;
